import { crv, cva } from '@/styled-system/css';

const sizeVariants = crv('size', {
  xs: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '360px',
  },
  sm: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '540px',
  },
  md: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '720px',
  },
  lg: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '900px',
  },
  xl: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '1080px',
  },
  fullScreen: {
    blockSize: '100%',
    borderRadius: 'obj.fullWidth',
    maxInlineSize: '100%',
  },
});

export const modalContentRecipe = cva({
  base: {
    'display': 'flex',
    'flexDirection': 'column',
    'backgroundColor': 'bg.elevated.sheet',
    'boxShadow': 'lg',
    'position': 'relative',
    'blockSize': 'auto',
    'inlineSize': '100%',
    'minBlockSize': '0',
    // TODO: use animation tokens when available
    'animation': 'zoom-in 0.2s ease-out',
    'zIndex': 2,

    '&:not(:has(.c11n_modal__header))': {
      paddingBlockStart: 'layout.loosest',
    },
  },
  variants: {
    scrollDocument: {
      true: {},
      false: {
        maxBlockSize: '100%',
      },
    },
    ...sizeVariants,
  },
});
